export const formatedVehicleObj = vehicle => {
  return {
    make: vehicle.make,
    year: vehicle.year,
    model: vehicle.modelBase || vehicle.model,
    transmissionType: vehicle.transmission || vehicle.transmissionType,
    driveType: vehicle.driveType,
    trim: vehicle.trim,
    engineSize: vehicle.engineSize,
    engineType: vehicle.engineType,
    vin: vehicle.vin
  };
};

export const compareMYM = (
  { make: make1, year: year1, model: model1 },
  { make: make2, year: year2, model: model2 }
) => make1 === make2 && year1 === year2 && model1 === model2;

export const compareMYMT = (
  {
    transmissionType: transmissionType1,
    driveType: driveType1,
    trim: trim1,
    engineSize: engineSize1,
    engineType: engineType1,
    ...vehicle1
  },
  {
    transmissionType: transmissionType2,
    driveType: driveType2,
    trim: trim2,
    engineSize: engineSize2,
    engineType: engineType2,
    ...vehicle2
  }
) =>
  compareMYM(vehicle1, vehicle2) &&
  transmissionType1 === transmissionType2 &&
  driveType1 === driveType2 &&
  trim1 === trim2 &&
  engineSize1 === engineSize2 &&
  engineType1 === engineType2;



// WEBPACK FOOTER //
// ./src/utils/vehicle.js